import * as turf from "@turf/turf";

const MINZOOM_DETAILS = 15;

const NUMBERS_LAYOUT = {
  "text-justify": "auto",
  "text-allow-overlap": true,
  /*"text-ignore-placement": true,*/
  "text-size": [
    "interpolate",
    ["linear"],
    ["zoom"],
    15.5,
    0.5,
    19,
    17,
  ],
  //"text-font": ["DIN Pro Bold", "Arial Unicode MS Regular"],
  "text-font": ["Montserrat SemiBold", "Arial Unicode MS Regular"],
};

let lastUsedClassColors = {};
function generateColorExpression(colors, darken = false) {
  if (!colors || typeof colors != "object" || Array.isArray(colors) || !Object.keys(colors).length) {
    console.warn("Illegal classColors object:", colors);
    return "transparent";
  }

  let colorsById = {};
  let colorsByClass = {};
  Object.keys(colors).forEach((key) => {
    if (Number(key)) colorsById[key] = colors[key];
    else colorsByClass[key] = colors[key];
  });//TODO refactorati kad izgradimo novi backend i postavimo sve da ide preko id-a

  colorsByClass = Object.assign({}, lastUsedClassColors, colorsByClass);

  let colorExpression = ["case"];
  for (let [id, color] of Object.entries(colorsById))
    colorExpression.push(
      ["all", ["==", ["get", "id"], String(id)], ["!=", ["slice", ["get", "class"], 0, 9], "unit_base"], ["!=", ["get", "class"], "pool"]], // TODO refaktorirati kad napravimo novi backend
      darken ? changeBrightness(color, 25) : color
    );
  for (let [featureClass, color] of Object.entries(colorsByClass)) { // TODO refactor
    //class is a reserved keyword in js so the variable name is featureClass
    if(featureClass === "unit_base_gray") {
      colorExpression.push(
        ["==", ["get", "class"], "unit_base_gray"],
        darken ? '#709F50' : color
      );
    }
    if(featureClass === "unit_base_green") {
      colorExpression.push(
        ["==", ["get", "class"], "unit_base_green"],
        darken ? '#709F50' : color
      );
    }
    colorExpression.push(
      ["all", ["==", ["get", "terrace"], "true"], ["==", ["get", "class"], String(featureClass)]],
      darken ? color : changeBrightness(color, -25)
    );
    colorExpression.push(
      ["==", ["get", "class"], String(featureClass)],
      darken ? changeBrightness(color, 25) : color
    );
  }
  colorExpression.push("transparent");

  lastUsedClassColors = colorsByClass;
  return colorExpression;
}

function repaintMap(campsaboutObject) {
  const colorExpression = generateColorExpression(campsaboutObject.colors, false);
  const colorExpressionDarken = generateColorExpression(campsaboutObject.colors, true);
  if (campsaboutObject.map.getLayer("camp-fill-layer"))
    campsaboutObject.map.setPaintProperty("camp-fill-layer", "fill-color", colorExpression);
  if (campsaboutObject.map.getLayer("camp-fill-numbers-layer")){
    campsaboutObject.colors = {...campsaboutObject.colors, ...lastUsedClassColors }
    campsaboutObject.map.setPaintProperty("camp-fill-numbers-layer", "text-color", getTextColorExpression(campsaboutObject, false));
    campsaboutObject.map.setPaintProperty("camp-fill-numbers-layer", "text-halo-color", getTextColorExpression(campsaboutObject, true));
  }
  if (campsaboutObject.map.getLayer("camp-fill-layer-outline"))
    campsaboutObject.map.setPaintProperty("camp-fill-layer-outline", "line-color", colorExpressionDarken);
  if (campsaboutObject.map.getLayer("camp-extrusion-layer"))
    campsaboutObject.map.setPaintProperty("camp-extrusion-layer", "fill-extrusion-color", colorExpression);
}

function createCentroidFeatures(geojson) {
  let centroids = {
    type: "FeatureCollection",
    features: [],
  };
  const poiNumbers = geojson.features.filter(
      (item, i) => item.properties.number
  );
  for (const item of poiNumbers) {
    try {
      // Check if the geometry coordinates are valid
      if (item.geometry && item.geometry.coordinates && Array.isArray(item.geometry.coordinates)) {
        centroids.features.push(
            turf.centerOfMass(item.geometry, {
              properties: {
                number: item.properties.number,
                class: item.properties.class,
                id: item.properties.id,
              },
            })
        );
      }
    } catch (error) {
      if (error.message.includes("coordinates must contain numbers")) {
        console.warn(`Skipping item with invalid coordinates: ${item.properties.id}`);
      } else {
        throw error; // Re-throw if it's a different error
      }
    }
  }

  return centroids;
}

function changeBrightness(hex, percent) {
  if (hex === "transparent") {
    return hex;
  }
  // Remove the '#' from the hex string if present
  hex = hex.replace(/^#/, "");

  // Convert hex to RGB
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Decrease the RGB values by the percentage provided
  r = Math.max(0, Math.min(255, Math.floor(r * (1 - percent / 100))));
  g = Math.max(0, Math.min(255, Math.floor(g * (1 - percent / 100))));
  b = Math.max(0, Math.min(255, Math.floor(b * (1 - percent / 100))));

  // Convert the RGB values back to hex and return
  return `#${((r << 16) + (g << 8) + b).toString(16).padStart(6, "0")}`;
}



function setupFill(campsaboutObject) {
  if (!campsaboutObject || !campsaboutObject.map || !campsaboutObject.sortedCampGeojson || !campsaboutObject.sortedCampGeojson.fill) return;

  const sourceName = "camp-fill-source";
  campsaboutObject.map.addSource(sourceName, {
    type: "geojson",
    data: campsaboutObject.sortedCampGeojson.fill,
  });

  const colorExpression = generateColorExpression(campsaboutObject.colors);
  const lineColorExpression = generateColorExpression(campsaboutObject.colors, true);

  campsaboutObject.map.addLayer({
    id: "camp-fill-layer",
    type: "fill",
    source: sourceName,
    paint: {
      "fill-antialias": false,
      /*"fill-outline-color": 'transparent',*/
      "fill-color": colorExpression,
      "fill-opacity": 0.5
    },
  });

  campsaboutObject.map.addLayer({
    id: "camp-fill-layer-outline",
    type: "line",
    source: sourceName,
    minzoom: MINZOOM_DETAILS,
    paint: {
      "line-blur": 0,
      "line-color": lineColorExpression,
      "line-width": [
        "case",
        ["==", ["slice", ["get", "class"], 0, 9], "unit_base"],
        2,
        ["!=", ["get", "number"], null],
        0.4,
        ["==", ["get", "class"], "road"],
        0.2,
        0
      ],
    },
  });

  campsaboutObject.map.addSource('camp-fill-centroid-source', {
    type: "geojson",
    data: createCentroidFeatures(campsaboutObject.sortedCampGeojson.fill),
  });
  console.log(getTextColorExpression(campsaboutObject))
  campsaboutObject.map.addLayer({
    id: "camp-fill-numbers-layer",
    type: "symbol",
    source: "camp-fill-centroid-source",
    minzoom: MINZOOM_DETAILS,
    layout: {
      "text-field": [
        "coalesce",
        ["case",
          ["all",
            ["has", "number"], // Ensure the feature has an "id" property
            ["!=", ["get", "terrace"], "true"] // Ensure terrace is not "true"
          ],
          ["get", ["to-string", ["get", "id"]], ["literal", campsaboutObject.numberArr]], // Get the value from numberValuesObject based on the id
          ""
        ],
        ""
      ],
      ...NUMBERS_LAYOUT,
    },
    paint: {
      "text-color": getTextColorExpression(campsaboutObject),  // Dynamic text color based on brightness
      "text-opacity": 0.8,
      "text-halo-color": getTextColorExpression(campsaboutObject, true),
      "text-halo-width": 0.5,
      "text-halo-blur": 0.2
    }
  });
}

function getTextColorExpression(campsaboutObject, reverse = false) {
  const colorMap = new Map(); // Map to store unique IDs and colors

  // Iterate over colors in campsaboutObject.colors
  Object.keys(campsaboutObject.colors).forEach((code) => {
    const color = campsaboutObject.colors[code];
    if (isHexColor(color)) {
      const calculatedColor = calculateBrightness(color, reverse);

      for (const feature of campsaboutObject.sortedCampGeojson.fill.features) {
        const id = String(feature.properties.id);

        // Check if the id is already in colorMap; if so, skip it
        if (colorMap.has(id)) continue;

        // Set color only if the id is not already present
        if ((feature.properties.id === code || feature.properties.class === code) && feature.properties.number) {
          colorMap.set(id, calculatedColor);
        }
      }
    }
  });

  // Transform colorMap into an array for match expression
  const colorExpression = ["match", ["get", "id"]];
  colorMap.forEach((color, id) => {
    colorExpression.push(id, color);
  });

  // Default color if there's no match
  colorExpression.push("#000001"); // Last default value
  return colorExpression;
}



function isHexColor(color) {
  return /^#([0-9A-F]{3}){1,2}$/i.test(color); // Test for valid 3 or 6 digit hex color
}

// Convert hex to RGB
function hexToRgb(hex) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

// Calculate relative luminance
function getLuminance(rgb) {
  const a = [rgb.r, rgb.g, rgb.b].map(v => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

// Calculate contrast ratio
function getContrastRatio(luminance1, luminance2) {
  const lightest = Math.max(luminance1, luminance2);
  const darkest = Math.min(luminance1, luminance2);
  return (lightest + 0.05) / (darkest + 0.05);
}

// Determine best text color
function calculateBrightness(bgHex, reverse = false) {
  const bgRgb = hexToRgb(bgHex);
  const bgLuminance = getLuminance(bgRgb);
  const whiteLuminance = getLuminance({r: 255, g: 255, b: 255});
  const blackLuminance = getLuminance({r: 0, g: 0, b: 0});

  const whiteContrast = getContrastRatio(bgLuminance, whiteLuminance);
  const blackContrast = getContrastRatio(bgLuminance, blackLuminance);

  if(reverse){
    return whiteContrast > blackContrast ? '#000000' : '#FFFFFF';
  }else{
    return whiteContrast > blackContrast ? '#FFFFFF' : '#000000';
  }

}

function setupExtrusion(campsaboutObject) {
  if (!campsaboutObject || !campsaboutObject.map || !campsaboutObject.sortedCampGeojson || !campsaboutObject.sortedCampGeojson.extrusion) return;
  const sourceName = "camp-extrusion-source";
  campsaboutObject.map.addSource(sourceName, {
    type: "geojson",
    data: campsaboutObject.sortedCampGeojson.extrusion,
  });

  const colorExpression = generateColorExpression(campsaboutObject.colors);

  campsaboutObject.map.addLayer({
    id: "camp-extrusion-layer",
    type: "fill-extrusion",
    source: sourceName,
    paint: {
      "fill-extrusion-color": colorExpression,
      "fill-extrusion-height": ["coalesce", ["feature-state", "height"], ["get", "height"], 2],
    },
  });
  campsaboutObject.map.addLayer({
    id: "camp-extrusion-numbers-layer",
    type: "symbol",
    source: sourceName,
    minzoom: MINZOOM_DETAILS,
    layout: {
      ...NUMBERS_LAYOUT,
      "symbol-z-elevate": true,
      "symbol-placement": "point",
      "symbol-z-order": "auto",
    },
  });
}

function setupLine(campsaboutObject) {
  if (!campsaboutObject || !campsaboutObject.map || !campsaboutObject.sortedCampGeojson || !campsaboutObject.sortedCampGeojson.line) return;
  const sourceName = "line-source";
  campsaboutObject.map.addSource(sourceName, {
    type: "geojson",
    data: campsaboutObject.sortedCampGeojson.line,
  });

  const colorExpression = generateColorExpression(campsaboutObject.colors);

  campsaboutObject.map.addLayer({
    id: "line-layer",
    type: "line",
    source: sourceName,
    layout: {
      "line-cap": "round",
    },
    paint: {
      "line-color": colorExpression,
      "line-dasharray": [
        'case',
        ['==', ['get', 'class'], 'fence'], // If "class" is "fence"
        [2, 2], // Dotted line (2px dash, 2px gap)
        [1, 0]  // Solid line (no dash pattern)
      ]
    },
  });
}

function setupPoi(campsaboutObject) {
  if (!campsaboutObject || !campsaboutObject.map || !campsaboutObject.sortedCampGeojson) return;
  const sourceName = "poi-source";
  campsaboutObject.map.addSource(sourceName, {
    type: "geojson",
    data: campsaboutObject.sortedCampGeojson.poi,
  });
  campsaboutObject.map.addLayer({
    id: "poi-layer",
    type: "symbol",
    source: sourceName,
    minzoom: MINZOOM_DETAILS,
    layout: {
      "icon-image": ["get", "icon"],
      "icon-allow-overlap": true,
      "icon-size": [
        "interpolate",
        ["linear"],
        ["zoom"],
        14,
        0,
        15.5,
        ["match", ["get", "icon"], ["ico-info-01"], 0.4, 0],
        19,
        0.7,
      ],
    },
  });
}

function setupLabel(campsaboutObject) {
  if (!campsaboutObject || !campsaboutObject.map || !campsaboutObject.labelsGeojson) return;
  const sourceName = "label-source";
  campsaboutObject.map.addSource(sourceName, {
    type: "geojson",
    data: campsaboutObject.labelsGeojson,
  });
  campsaboutObject.map.addLayer({
    id: "label-layer",
    type: "symbol",
    source: sourceName,
    minzoom: MINZOOM_DETAILS,
    layout: {
      "text-field": ["get", "description"],
      "text-allow-overlap": true,
      "text-font": ["Montserrat SemiBold", "Arial Unicode MS Regular"],
      "text-size": ["interpolate", ["linear"], ["zoom"], 15.5, ["get", "fontmin"], 19, ["get", "fontmax"]],
      "text-rotate": ["get", "rotation"],
      "text-rotation-alignment": "map",
      "text-variable-anchor": ["center"],
      "text-radial-offset": 0,
      "text-justify": "auto"
    },
    paint: {
      "text-color": ["get", "color"],
      "text-halo-color": ["get", "halo"],
      "text-halo-width": ["get", "halow"],
    }
  });
}

function setupFillFilter(campsaboutObject, highlightIds) {
  if (!campsaboutObject || !campsaboutObject.map || !campsaboutObject.sortedCampGeojson || !campsaboutObject.sortedCampGeojson.fill) return;
  const sourceName = "camp-fill-source";
  const layerId = "camp-fill-filter-layer";

  // Check if the layer already exists
  if (campsaboutObject.map.getLayer(layerId)) {
    // Update the filter of the existing layer
    campsaboutObject.map.setFilter(layerId, ["!in", "id", ...highlightIds]);
  } else {
    // If the layer doesn't exist, add it
    campsaboutObject.map.addLayer(
      {
        id: layerId,
        type: "fill",
        source: sourceName,
        filter: ["!in", "id", ...highlightIds],
        paint: {
          "fill-color": "white", // Semi-transparent shadow
          "fill-opacity": 1,
        },
      },
      "camp-fill-layer"
    );
  }
}

export default {
  setupFill,
  setupExtrusion,
  setupLine,
  setupPoi,
  setupLabel,
  repaintMap,
  setupFillFilter,
};
